import React, {Component} from 'react';
import Card from 'Utils/Cards/Card';
import FiltrosHeader from '../FiltrosHeader';
import TabBar from 'rc-tabs/lib/TabBar';
import TabContent from 'rc-tabs/lib/TabContent';
import Tabs, {TabPane} from 'rc-tabs';
import Reporte from './Reporte';
import CardEmpty from '../../../Utils/Cards/CardEmpty';
import { actions as printActions } from 'Utils/Print';
import moment from 'moment';

export default class ReporteRecepcionesKgSecos extends Component {
    state = {
        readyToPrint: false,
        isPrinting: false,
    };

    componentDidMount() {
        window.addEventListener('beforeprint', this.handleBeforePrint);
        window.addEventListener('afterprint', this.handleAfterPrint);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeprint', this.handleBeforePrint);
        window.removeEventListener('afterprint', this.handleAfterPrint);
    }

    handleBeforePrint = () => {
        this.setState({ isPrinting: true });
    };

    handleAfterPrint = () => {
        this.setState({ isPrinting: false }, () => {
            // Recargar datos con paginación después de imprimir
            this.props.getRecepcionesParaReporte(true, true);
        });
    };

    imprimirBoleta = async (event) => {
        if (event) event.persist();
        if (event && event.target) event.target.disabled = true;

        // Siempre realiza la consulta antes de imprimir (sin paginación)
        await this.props.getRecepcionesParaReporte(false, false);

        // Marca que debe imprimir cuando los datos estén listos
        this.setState({ readyToPrint: true, isPrinting: true });

        if (event && event.target) event.target.disabled = false;
    }

    componentDidUpdate(prevProps, prevState) {
        // Solo imprime si readyToPrint es true, los datos existen y el loader es false
        if (
            this.state.readyToPrint &&
            this.props.reporte.recepciones &&
            !this.props.loader
        ) {
            printActions.print('reporte-recepciones-kg-secos');
            this.setState({ readyToPrint: false });
        }
    }

    descargarExcel = () => {
        this.props.descargarReporteExcel();
    }

    render() {
        const {
            reporte, tipoMateriaChange,
            pageReporteLatexChange, fechaInicialLatexChange, fechaFinalLatexChange, fincaLatexChange, acopioLatexChange,
            pageReporteSolidoChange, fechaInicialSolidoChange, fechaFinalSolidoChange, fincaSolidoChange, acopioSolidoChange,
            materiaLatexChange, materiaSolidoChange,filtroReporteKgSecosPerfilFinca,filtro_perfil_finca_reporte_kg_secos,
            buscarIdLatexChange, buscarIdSolidoChange
        } = this.props;

        let fechaInicialChange = null, fechaFinalChange = null, fincaChange = null, acopioChange = null, materiaChange = null, pageChange = null, buscarIdChange = null;
        let fecha_inicial = null, fecha_final = null, finca_id = null, acopio_id = null, materia_id = null, page = null, id_buscar = null;
        switch(reporte.tipo_materia) {
            case 'LATEX':
                pageChange = pageReporteLatexChange;
                fechaInicialChange = fechaInicialLatexChange;
                fechaFinalChange = fechaFinalLatexChange;
                fincaChange = fincaLatexChange;
                acopioChange = acopioLatexChange;
                materiaChange = materiaLatexChange;
                page = reporte.latex_page;
                fecha_inicial = reporte.latex_fecha_inicial;
                fecha_final = reporte.latex_fecha_final;
                finca_id = reporte.latex_finca_id;
                acopio_id = reporte.latex_acopio_id;
                materia_id = reporte.latex_materia_id;
                buscarIdChange = buscarIdLatexChange;
                id_buscar = reporte.id_buscar_latex;
                break;
            case 'SOLIDO':
                pageChange = pageReporteSolidoChange;
                fechaInicialChange = fechaInicialSolidoChange;
                fechaFinalChange = fechaFinalSolidoChange;
                fincaChange = fincaSolidoChange;
                acopioChange = acopioSolidoChange;
                materiaChange = materiaSolidoChange;
                page = reporte.solido_page;
                fecha_inicial = reporte.solido_fecha_inicial;
                fecha_final = reporte.solido_fecha_final;
                finca_id = reporte.solido_finca_id;
                acopio_id = reporte.solido_acopio_id;
                materia_id = reporte.solido_materia_id;
                buscarIdChange = buscarIdSolidoChange;
                id_buscar = reporte.id_buscar_solido;
                break;
        }
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="reportes_activo"
                    titulo="RECEPCIONES (KG. SECOS)"
                    noBorder
                    subtitulo="Reporte">
                    <Tabs
                        activeKey={reporte.tipo_materia}
                        tabBarPosition="top"
                        onChange={tipo_materia => {tipoMateriaChange(tipo_materia)}}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}>
                        <TabPane tab="LÁTEX" key="LATEX">
                            <div></div>
                        </TabPane>
                        <TabPane tab="SÓLIDOS" key="SOLIDO">
                            <div></div>
                        </TabPane>
                    </Tabs>
                    <CardEmpty>
                        <FiltrosHeader {...this.props}
                            fechaInicialChange={fechaInicialChange} fecha_inicial={fecha_inicial}
                            fechaFinalChange={fechaFinalChange} fecha_final={fecha_final}
                            filtroFincaChange={fincaChange} finca_id={finca_id}
                            filtroAcopioChange={acopioChange} acopio_id={acopio_id}
                            filtroMateriasChange={materiaChange} materias_ids={materia_id} tipo_materia={reporte.tipo_materia}
                            filtroPerfilChange={filtroReporteKgSecosPerfilFinca} perfiles_finca_ids={filtro_perfil_finca_reporte_kg_secos}
                            precioReporteAmoniaco={undefined}
                            concentracionReporteAmoniaco={undefined}
                            styleCustomContainer={"justify-content-between"}
                            filtrarXReporte={()=>{this.props.getRecepcionesParaReporte(false)}}
                            labelXReporte={"Filtrar"}
                            botonImprimir={this.imprimirBoleta}
                            botonExportar={this.descargarExcel}
                            buscarIdChange={buscarIdChange}
                            id_buscar={id_buscar}
                        />
                    </CardEmpty>
                    <div className="mb-4"></div>
                    <Reporte {...this.props} pageChange={pageChange} page={page} isPrinting={this.state.isPrinting}></Reporte>
                </Card>
            </div>
        )
    }
}
